import {
    IConfigSchema,
    TYPE_COLUMN_TOTAL,
    TYPE_COLUMN_HIGH_CHART,
    TYPE_COLUMN_TABLE
} from '@/containers/E4ImpactProjects/resources/config-schema';
import {entrepreneursDidNotProductsTotalCalculation} from './total-calculations/entrepreneurs-did-not-products-total-calculation';
import {businessModelImprovementChartCalculation} from './chart-calculations/business-model-improvement-chart-calculation';
import {businessModelImprovementTotalCalculation} from './total-calculations/business-model-improvement-total-calculation';
import {levelImprovementChartCalculation} from './chart-calculations/level-improvement-chart-calculation';
import {
    entrepreneursRequestedFundsBeforeAccelerationProgramChartCalculation
} from './chart-calculations/entrepreneurs-requested-funds-before-acceleration-program-chart-calculation';
import {
    kindFundsObtainedBeforeAccelerationProgramChartCalculation
} from './chart-calculations/kind-funds-obtained-before-acceleration-program-chart-calculation';
import {entrepreneursBaselineObtainedFundsChartCalculation} from './chart-calculations/entrepreneurs-baseline-obtained-funds-chart-calculation';
import {baselineMainFailureFactorsChartCalculation} from './chart-calculations/baseline-main-failure-factors-chart-calculation';
import {entrepreneursWhoRequestedFundsDuringTheProgramChartCalculation} from './chart-calculations/entrepreneurs-who-requested-funds-during-the-program-chart-calculation';
import {kindOfFundsChartCalculation} from './chart-calculations/kind-of-funds-chart-calculation';
import {averageAmountOfFundsRequestedPerTypeOfFundsTableCalculation} from './table-caclulations/average-amount-of-funds-requested-per-type-of-funds-table-calculation';
import {entrepreneursFinalObtainedFundsChartCalculation} from './chart-calculations/entrepreneurs-final-obtained-funds-chart-calculation copy';
import {mainSuccessFactorsChartCalculation} from './chart-calculations/main-success-factors-chart-calculation';
import {accelerationProgramContributionToAccessFundsChartCalculation} from './chart-calculations/acceleration-program-contribution-to-access-funds-chart-calculation';
import {finalMainFailureFactorsChartCalculation} from './chart-calculations/final-main-failure-factors-chart-calculation';
import {entrepreneursThatOpenedNewSalesChannelsChartCalculation} from './chart-calculations/entrepreneurs-that-opened-new-sales-channels-chart-calculation';
import {typeOfNewSalesChannelsChartCalculation} from './chart-calculations/type-of-new-sales-channels-chart-calculation';
import { existingEntrepreneursSellingOnMarketChartCalculation } from './chart-calculations/existing-entrepreneurs-selling-on-market-chart-calculation';
import { entrepreneursWhoIncreasedGeographicalAreaOfActivityChartCalculation } from './chart-calculations/entrepreneurs-who-increased-geographical-area-of-activity-chart-calculation';
import { entrepreneursThatIncreasedCustomerNetworkChartCalculation } from './chart-calculations/entrepreneurs-that-increased-customer-network-chart-calculation';

export const configSchema = (props: any): IConfigSchema => ([
    {
        titleSection: {
            title: 'Market entry'
        },
        rows: [
            {
                columns: [
                    {
                        title: '% entrepreneurs that did not have products on the market',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: entrepreneursDidNotProductsTotalCalculation(props),
                    },
                ]
            },
        ]
    },
    {
        titleSection: {
            title: 'Business Model improvement during the program'
        },
        rows: [
            {
                columns: [
                    {
                        title: 'Average improvement',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: businessModelImprovementTotalCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: businessModelImprovementChartCalculation(props),
                    },
                ]
            },
        ]
    },
    {
        titleSection: {
            title: 'Level of improvement of book keeping (frequency)'
        },
        rows: [
            {
                columns: [
                    {
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: levelImprovementChartCalculation(props),
                    },
                ]
            },
        ]
    },
    {
        titleSection: {
            title: 'Funds raised before'
        },
        rows: [
            {
                columns: [
                    {
                        title: 'KPI: % of entrepreneurs who requested funds before the acceleration program',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: entrepreneursRequestedFundsBeforeAccelerationProgramChartCalculation(props),
                    },
                    {
                        title: 'KPI: Kind of Funds obtained before the acceleration program',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: kindFundsObtainedBeforeAccelerationProgramChartCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'KPI: % of entrepreneurs who obtained the funds',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: entrepreneursBaselineObtainedFundsChartCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'KPI: Main failure factors',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: baselineMainFailureFactorsChartCalculation(props),
                    },
                ]
            },
        ]
    },
    {
        titleSection: {
            title: 'Funds raised during the program - NEW'
        },
        rows: [
            {
                columns: [
                    {
                        title: 'KPI: % of entrepreneurs who requested funds during the program',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: entrepreneursWhoRequestedFundsDuringTheProgramChartCalculation(props),
                    },
                    {
                        title: 'KPI: Kind of Funds',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: kindOfFundsChartCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'KPI: Average amount of funds requested per type of funds',
                        typeChart: TYPE_COLUMN_TABLE,
                        transformData: averageAmountOfFundsRequestedPerTypeOfFundsTableCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'KPI: % of entrepreneurs who obtained the funds',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: entrepreneursFinalObtainedFundsChartCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'KPI: Main success factors',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: mainSuccessFactorsChartCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'KPI: E4I Acceleration Program contribution to access funds',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: accelerationProgramContributionToAccessFundsChartCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'KPI: Main failure factors',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: finalMainFailureFactorsChartCalculation(props),
                    },
                ]
            },
        ]
    },
    {
        titleSection: {
            title: 'Access to market'
        },
        rows: [
            {
                columns: [
                    {
                        title: '% of entrepreneurs that opened new sales channels',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: entrepreneursThatOpenedNewSalesChannelsChartCalculation(props),
                    },
                    {
                        title: 'Type of new sales channels',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: existingEntrepreneursSellingOnMarketChartCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'Type of new sales channels',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: typeOfNewSalesChannelsChartCalculation(props),
                    },
                ]
            },
        ]
    },
    {
        titleSection: {
            title: 'Geographical area of activity'
        },
        rows: [
            {
                columns: [
                    {
                        title: 'KPI: % of entrepreneurs who increased the geographical area of activity',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: entrepreneursWhoIncreasedGeographicalAreaOfActivityChartCalculation(props),
                    },
                    {
                        title: '% of entrepreneurs that increased the customer network',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: entrepreneursThatIncreasedCustomerNetworkChartCalculation(props),
                    },
                ]
            },
        ]
    }
]);